module.exports = __webpack_public_path__ + "img/undraw_void_3ggu.0619d0c8.png";